export const genericModal = async () => {
  const body = document.querySelector('body');
  const closeTriggers = document.querySelectorAll('[js-close-modal]');
  const backdrops = document.querySelectorAll('[js-modal-backdrop]');
  const modals = document.querySelectorAll('[js-generic-modal]');
  const modalTriggers = document.querySelectorAll('[js-modal-trigger]');

  const navigation = document.getElementById('navigation');

  if (!backdrops || !modals || !body || !modalTriggers) {
    return;
  }

  const getBackdropsForModal = (modalId: string | null) =>
    Array.from(backdrops).filter((backdrop) => {
      const scope = backdrop.getAttribute('js-modal-backdrop');
      return !scope || scope === modalId;
    });

  // TK: add a host allow-list once the trusted embed provider(s) are confirmed.
  const isSafeIframeSrc = (src: string) => {
    try {
      return new URL(src).protocol === 'https:';
    } catch {
      return false;
    }
  };

  modalTriggers.forEach((item) => {
    item.addEventListener('click', () => {
      const modalId = item.getAttribute('js-modal-id');
      const modalToTrigger = Array.from(modals).find((modal) => modal.id === modalId);

      if (modalToTrigger) {
        const iframeSrc = item.getAttribute('js-iframe-modal-src');
        const iframe = modalToTrigger.querySelector<HTMLIFrameElement>('[js-iframe-modal-frame]');

        if (iframeSrc && iframe) {
          if (!isSafeIframeSrc(iframeSrc)) {
            return;
          }
          iframe.src = iframeSrc;
        }

        modalToTrigger.classList.add('generic-modal__outer--active');
      }
      item.setAttribute('aria-expanded', 'true');
      getBackdropsForModal(modalId).forEach((backdrop) => {
        backdrop.classList.add('backdrop-active');
      });
      body.classList.add('overflow--hidden');

      if (modalId == 'currency-modal' && navigation) {
        navigation.classList.add('overflow--hidden');
        navigation.classList.remove('overflow--scroll-y');
      }
    });
  });

  const closeModal = () => {
    modalTriggers.forEach((item) => {
      item.addEventListener('click', () => {
        item.setAttribute('aria-expanded', 'false');
      });
    });
    backdrops.forEach((item) => {
      item.classList.remove('backdrop-active');
    });
    const openModal = document.querySelector('.generic-modal__outer--active');
    if (openModal) {
      openModal.classList.remove('generic-modal__outer--active');
      const iframe = openModal.querySelector<HTMLIFrameElement>('[js-iframe-modal-frame]');
      if (iframe) {
        iframe.src = '';
      }
    }
    body.classList.remove('overflow--hidden');

    if (navigation) {
      navigation.classList.remove('overflow--hidden');
      navigation.classList.add('overflow--scroll-y');
    }
  };

  backdrops.forEach((item) => {
    item.addEventListener('click', closeModal);
  });
  closeTriggers.forEach((item) => {
    item.addEventListener('click', closeModal);
  });
};
